import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body14Styles, body16MainStyles } from "@constants/typography"
import { MobileAndDesktopOnly, TabletOnlyContainer } from "@utils/MediaQuery"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  @media ${breakpoints.tablet} {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;

    ${TabletOnlyContainer} {
      width: 100%;
    }
  }
`

const LeftOnTablet = styled.div`
  @media ${breakpoints.tablet} {
    width: 50%;
  }
`

const ShippingRow = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const ShippingTextWrapper = styled.div`
  margin-right: 14px;
`

const ShippingTextMargin = styled.div`
  height: 32px;
`

const OutOfStockMessage = styled.div`
  ${body16MainStyles}
  display: flex;
  margin-top: 10px;
  align-content: center;
  justify-content: center;
  color: ${colors.brandOrange};

  @media ${breakpoints.tablet} {
    margin-top: 14px;
    justify-content: flex-start;
    font-size: 14px;
  }

  @media ${breakpoints.laptop} {
    ${body14Styles}
    justify-content: flex-start;
    color: ${colors.brandOrange};
  }
`

interface ShippingBlockWithoutFormProps {
  outOfStockMessage?: string
  shippingText: React.ReactNode
}

const ShippingBlockWithoutForm = (props: ShippingBlockWithoutFormProps) => {
  return (
    <Container>
      <LeftOnTablet>
        <ShippingTextMargin />
        <ShippingRow>
          <ShippingTextWrapper>{props.shippingText}</ShippingTextWrapper>
        </ShippingRow>
        {props.outOfStockMessage && (
          <MobileAndDesktopOnly>
            <OutOfStockMessage>{props.outOfStockMessage}</OutOfStockMessage>
          </MobileAndDesktopOnly>
        )}
      </LeftOnTablet>
      {props.outOfStockMessage && (
        <TabletOnlyContainer>
          <OutOfStockMessage>{props.outOfStockMessage}</OutOfStockMessage>
        </TabletOnlyContainer>
      )}
    </Container>
  )
}

export default ShippingBlockWithoutForm
